import { IconButton, Tooltip, Typography } from "@mui/material"
import { CommonService } from "../../Service/CommonService"
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useLocation } from "react-router";
import SearchIcon from "@mui/icons-material/Search";
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

const ViewTastingHistory = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const [showContainerTimeline, setShowContainerTimeline] = useState(false);
    const [showContainerHistory, setShowContainerHistory] = useState(false);
    const [rows, setRows] = React.useState([]);
    const [totalCount, setTotalCount] = React.useState(0);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [sortModel, setSortModel] = React.useState([]);
    const [searchText, setSearchText] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    function routeBack() {

    }

    return (
        <>
            <div
                className="usersList usersList__user tasting-history-detail container-history-detail"
                style={{ paddingBottom: CommonService.isAdmin() ? 47 : "" }}>
                <div className="usersList__header--wrapper d-flex flex-wrap align-items-center w-100">
                    <div className="d-flex align-items-center justify-content-between w-100 flex-wrap gap-2 position-relative">
                        <div className="d-flex align-items-center gap-2 flex-wrap left-wrapper">
                            {CommonService.isAdmin() && (
                                <>
                                    <div className="back__button" onClick={routeBack}>

                                        <IconButton
                                            aria-label="ArrowBackIcon"
                                            sx={{ backgroundColor: "#FFF" }}
                                        >
                                            <ArrowBackIcon sx={{ color: "#1C1B1F" }} />
                                        </IconButton>
                                    </div>

                                    <div className="header--title">
                                        <h1 className="title mb-0">
                                            Tasting History Detail
                                        </h1>
                                    </div>
                                    <div className="divider mx-2"></div>
                                </>
                            )}
                            <div className="header--title d-flex flex-wrap me-auto mb-xxl-0 gap-2 gap-xxl-3">
                                <div className="time__details me-4 me-xl-4 mb-0">
                                    <Typography
                                        variant="h6"
                                        sx={{ color: "#333333", fontSize: "12px", fontWeight: 400 }}
                                    >
                                        Container Number
                                    </Typography>
                                    <Typography
                                        variant="h3"
                                        sx={{ color: "#333333", fontSize: "18px", fontWeight: 700 }}
                                    >
                                        17-17107
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="user-table-container position-relative">
                    <div className="userTable ">
                        <div className="tasting-history-detail-wrapper edit-history-detail-wrapper">
                            <div className="row gy-3">
                                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                    <div className="field description-field">
                                        <div className="label">Nose Notes</div>
                                        <div className="value">Warm baking spice and cracked black pepper upfront, followed by toasted oak, light citrus zest, and herbal rye grain. Subtle vanilla bean and dried apricot appear as the spirit opens.</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                    <div className="field description-field">
                                        <div className="label">Palate Notes</div>
                                        <div className="value">Sweet caramel and honey at the entry, evolving into bold rye spice and pepper. Medium-bodied mouthfeel with toasted cereal, hints of cocoa, and orange peel. Spice builds mid-palate with good structure.</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                    <div className="field description-field">
                                        <div className="label">Finish Notes</div>
                                        <div className="value">Long and warming finish with lingering clove, oak tannins, mint, and a lightly sweet fade. Dry and slightly earthy aftertaste.</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Timestamp</div>
                                        <div className="value">Dec 11, 2025, 3:48 AM</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-3 col-xl-2">
                                    <div className="field">
                                        <div className="label">Timestamp</div>
                                        <div className="value">Dec 11, 2025, 3:48 AM</div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-4 col-lg-6 col-xl-4">
                                    <div className="field description-field">
                                        <div className="label">Blender Comments</div>
                                        <div className="value">Strong rye-forward profile with excellent spice character and balanced oak integration. Suitable for spicy blend batches or potential single-barrel selection. Recommend usage within 12–18 months to avoid over-oaking.</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default ViewTastingHistory;